import ChatBox from './Components/ChatBox.vue';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import * as $ from 'jquery';

Vue.use(VeeValidate, {
  classes: true,
});

export async function initChatBox() {
  const element = document.querySelector('.js-chat-box');
  if (element) {
    const imageUrl = element.getAttribute('data-image');
    const imageNotAvailable = element.getAttribute('data-imagenotavailable');
    const url = element.getAttribute('data-url');

    new Vue({
      el: '.js-chat-box',
      template: '<ChatBox :url="url" :image="imageUrl" :imageNotAvailable="imageNotAvailable"/>',
      data: {imageUrl, url, imageNotAvailable},
      components: {ChatBox},
    });

    const onScroll = (event) => {
      const chatBox = $('.js-hideOnBottom');
      if (window.innerHeight >= (document.body.scrollHeight - window.scrollY - 20)) {
        chatBox.hide();
      } else {
        chatBox.show();
      }
    };
    window.addEventListener('scroll', onScroll, {passive: true});
  }
}
